import { renderResponseDetails } from "./sensor-response";

/**
 * The card that opens over an Alert Response cell while the pointer is on it:
 * the whole of what the Resolution Center says about the sensor (what fired,
 * who is on it, snoozes, who has seen it, the latest comment, the close)
 * without opening the sensor or the account. Below the cell, or above it when
 * there is no room; never past the window's edges. It is only ever looked at
 * -- clicking the row still opens the sensor.
 */
class ResponseHoverCard {

  constructor(getSensor) {
    this.getSensor = getSensor;
    this.el = null;
    this.timer = null;

    $('body')
      .on('mouseenter', '.data-grid-row__cell[data-for="response"]', e => {
        const row = e.currentTarget.closest('.data-grid-row');
        const sensor = row ? this.getSensor(row.dataset.sensor) : null;
        if (!sensor) return;
        clearTimeout(this.timer);
        // a short wait, so sweeping down the column doesn't flash a card per row
        this.timer = setTimeout(() => this.show(e.currentTarget, sensor), 120);
      })
      .on('mouseleave', '.data-grid-row__cell[data-for="response"]', () => {
        clearTimeout(this.timer);
        this.hide();
      });
  }

  show(cell, sensor) {
    if (!document.body.contains(cell)) return;

    if (!this.el) {
      this.el = document.createElement('div');
      this.el.className = 'arc-hovercard';
      this.el.setAttribute('role', 'tooltip');
      document.body.appendChild(this.el);
    }

    this.el.innerHTML = `
      <div class="arc-hovercard__sensor">
        <b>${window.escapeHTML(String(sensor.sensor_name || sensor.sensor_id))}</b>
        <span>${window.escapeHTML(String(sensor.account_name || ''))}</span>
      </div>
      ${renderResponseDetails(sensor)}
      <div class="arc-hovercard__foot">Click the row for readings and every alert</div>
    `;

    // measured where it can't be seen, then placed
    this.el.style.visibility = 'hidden';
    this.el.classList.add('is-visible');

    const rect = cell.getBoundingClientRect();
    const card = this.el.getBoundingClientRect();
    const gap = 6;
    const margin = 8;

    let top = rect.bottom + gap;
    if (top + card.height > window.innerHeight - margin && rect.top - gap - card.height > margin) {
      top = rect.top - gap - card.height;
    }
    top = Math.max(margin, Math.min(top, window.innerHeight - card.height - margin));

    const left = Math.max(margin, Math.min(rect.left, window.innerWidth - card.width - margin));

    this.el.style.top = `${top}px`;
    this.el.style.left = `${left}px`;
    this.el.style.visibility = '';
  }

  hide() {
    clearTimeout(this.timer);
    if (this.el) {
      this.el.classList.remove('is-visible');
    }
  }
}

export default ResponseHoverCard;
